import { DBUserSimple } from '@core/types/types.db';
import { QuestionListEndpoint } from '@core/types/types.endpoint.question';
import { getMarkdown } from '@core/util/util.getMarkdown';
import { timeAgo } from '@core/util/util.timeAgo';
import { callApi } from '@frontend/shared/util/util.callApi';

export async function exportCategoryMarkdown(
  categoryId: string,
  categoryName: string,
  users: DBUserSimple[],
): Promise<Error | null> {
  // Export is an explicit bulk operation; browse itself stays paginated.
  const questions: QuestionListEndpoint['response']['questions'] = [];
  let cursor: string | undefined;
  do {
    const [error, res] = await callApi<QuestionListEndpoint>('/question/list', {
      cursor,
      limit: 50,
    });
    if (error) return new Error(error.error);
    if (!res) return new Error('Failed to fetch questions');
    questions.push(
      ...res.questions.filter((q) => q.category_id === categoryId),
    );
    cursor = res.nextCursor;
  } while (cursor);

  const lines: string[] = [`# ${categoryName}`, ''];

  for (const question of questions) {
    lines.push(`## ${question.title}`);
    lines.push('');
    const md = getMarkdown(question.answer_json);
    if (md) {
      lines.push(md);
      lines.push('');
    }
    if (question.verified_by === 'UNVERIFIED') {
      lines.push(`*Unverified*`);
    } else {
      const user = users.find((u) => u.id === question.verified_by);
      const name = user?.name ?? 'Unknown';
      const when = timeAgo(question.verified_at);
      lines.push(`*Verified by ${name} — ${when}*`);
    }
    lines.push('');
  }

  const blob = new Blob([lines.join('\n')], {
    type: 'text/plain;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60_000);

  return null;
}
